var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgImgNotification44 = function SvgImgNotification44(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20_113)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "url(#paint0_linear_20_113)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    rx: 22,
    fill: "#0C0C0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.142 12.5714C19.8198 12.5714 16.29 13.788 14.4213 16.2212C13.3831 17.6405 12.7602 19.4654 12.7602 21.8986C12.7602 23.1152 12.9678 24.129 13.1755 25.1428C14.006 27.3733 12.7602 30.0092 10.4762 31.023C12.1373 31.4286 13.7984 31.4286 15.6671 30.8203C16.29 30.6175 16.9129 30.212 17.3282 30.0092C18.9893 31.023 21.0656 31.4286 23.142 31.4286C28.3329 31.4286 33.5238 28.5898 33.5238 22.1014C33.5238 15.4101 28.5405 12.5714 23.142 12.5714ZM23.142 25.7511C22.1038 25.7511 21.0656 25.3456 20.4427 24.7373C19.8198 23.9263 19.4045 22.9124 19.4045 21.8986C19.4045 21.2903 19.6122 20.682 19.8198 20.2765C20.4427 19.0599 21.4809 18.0461 23.3496 18.0461C25.8413 18.0461 27.0871 19.871 27.0871 21.8986C26.8795 23.9263 25.426 25.7511 23.142 25.7511Z",
    fill: "#E0E722"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_20_113",
    x1: 44,
    y1: 44,
    x2: -3.4544,
    y2: 39.8906,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#292928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0C0C0C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20_113"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgImgNotification44);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/img-notification-44.5b8c09a2e2053e968d402a06414e1138.svg";